<!-- src/components/social/DiscoverComponent.vue -->
<template>
  <v-container>
    <!-- Suchfeld -->
    <v-text-field
      dark
      v-model="searchQuery"
      label="Freunde suchen (Name, E-Mail)"
      prepend-inner-icon="mdi-magnify"
      filled
      rounded
      dense
      clearable
      hide-details
      class="mb-4"
      @input="debouncedSearch"></v-text-field>

    <!-- Ladeanzeige für Suche -->
    <div v-if="isSearching" class="text-center py-8">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <!-- Suchergebnisse -->
    <v-list dark v-else-if="results.length > 0" class="transparent">
      <v-subheader>Suchergebnisse</v-subheader>
      <v-list-item v-for="user in results" :key="user._id" @click="viewProfile(user._id)">
        <v-list-item-avatar>
          <v-img :src="user.bild ? '/img/profilbilder/' + user.bild : '/img/profilbilder/uploads/1741100494649.png'"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ user.vorname }} {{ user.nachname }}</v-list-item-title>
          <v-list-item-subtitle v-if="user.username">@{{ user.username }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <!-- Platzhalter, wenn nichts gefunden wurde oder Suche leer ist -->
    <div v-else class="text-center white--text py-16">
      <p v-if="searchQuery && !isSearching">Keine Benutzer gefunden.</p>
      <p v-else>Gib einen Namen oder eine E-Mail ein, um die Suche zu starten.</p>
    </div>
  </v-container>
</template>

<script>
import api from "@/api"
import _ from "lodash" // Lodash für Debounce

export default {
  data: () => ({
    searchQuery: "",
    results: [],
    isSearching: false,
  }),
  methods: {
    // Debounce verhindert, dass bei jedem Tastenanschlag eine API-Anfrage gesendet wird
    debouncedSearch: _.debounce(function () {
      this.search()
    }, 500),

    async search() {
      if (!this.searchQuery || this.searchQuery.length < 2) {
        this.results = []
        return
      }
      this.isSearching = true
      try {
        this.results = await api.social.searchUsers(this.searchQuery)
      } catch (error) {
        console.error("Fehler bei der Suche:", error)
      } finally {
        this.isSearching = false
      }
    },

    viewProfile(userId) {
      // Hier müsstest du zu einer Profil-Detailansicht navigieren
      // Da wir aber alles in einem Window haben, könnten wir ein Event emittieren
      // oder eine komplexere State-Management-Lösung verwenden.
      // Fürs Erste: Log.
      this.$emit("view-profile", userId)
    },
  },
}
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}
</style>
